import { graphql } from '../gql';

export const CHECK_TOKEN_VALIDITY = graphql(`
  query checkTokenValidity($token: String!) {
    checkTokenValidity(token: $token)
  }
`);
